/* LITTLEG-CHECKIN-ROUTE-STATE-01
 * Historical Check-in URL/complete-state compatibility implementation.
 * Not loaded by the current Place Context or Game asset loader; /pages/kid-map is the active public entry.
 * Retain this source until historical saved-record/deep-link contracts are verified at cutover.
 * Mission interaction remains in littleg-city-mission-engine-polish.js.
 * Persistence remains in window.LittleGResultStorage.
 * No direct storage-key access, backend call, score calculation or professional conclusion.
 */
(function littleGCheckinRouteState(window, document) {
  'use strict';

  var VERSION = 'LITTLEG-CHECKIN-ROUTE-STATE-01';
  var ROOT_SELECTOR = '[data-littleg-city-mission-engine]';

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function currentUrl() {
    try {
      return new URL(window.location.href);
    } catch (_error) {
      return null;
    }
  }

  function resultId(card) {
    return clean(card && (card.result_id || card.record_id || card.card_id || card.id));
  }

  function storageOwner() {
    var owner = window.LittleGResultStorage;
    return owner && typeof owner.getResult === 'function' ? owner : null;
  }

  function reveal(root, card) {
    if (!root || !card) return false;
    var id = resultId(card);
    if (!id) return false;

    root.setAttribute('data-checkin-state', 'complete');
    root.setAttribute('data-checkin-record-id', id);

    var finish = root.querySelector('[data-finish]');
    if (finish) {
      finish.__littleGMissionState = card;
      finish.hidden = false;
      finish.removeAttribute('hidden');
      finish.classList.add('is-visible');
      finish.setAttribute('aria-hidden', 'false');
      finish.setAttribute('data-status', 'saved');
      finish.setAttribute('data-saved-result-id', id);
      try {
        finish.dispatchEvent(
          new CustomEvent('littleg:hydrate-result-card', {
            bubbles: true,
            detail: { result: card },
          })
        );
      } catch (_error) {}
    }

    try {
      window.dispatchEvent(new CustomEvent('littleg:mission-state', { detail: card }));
    } catch (_error) {}

    var recordsLink = root.querySelector('a[href*="/pages/result-history"]');
    if (recordsLink) {
      try {
        var target = new URL(recordsLink.href, window.location.origin);
        if (
          target.origin !== window.location.origin ||
          !/\/pages\/result-history\/?$/.test(target.pathname)
        ) {
          throw new Error('unexpected records destination');
        }
        target.searchParams.delete('view');
        target.searchParams.set('record_id', id);
        target.searchParams.set('source', 'city-mission-complete');
        target.searchParams.set('intent', 'saved-record');
        recordsLink.href = target.pathname + target.search + target.hash;
      } catch (_error) {}
    }

    return true;
  }

  function writeCompleteUrl(id, replace) {
    var url = currentUrl();
    if (!url || !id) return;
    url.searchParams.set('state', 'complete');
    url.searchParams.set('record_id', id);
    url.searchParams.set('intent', 'check-in-complete');
    var next = url.pathname + url.search + url.hash;
    try {
      if (replace) window.history.replaceState(window.history.state, '', next);
      else window.history.pushState(window.history.state, '', next);
    } catch (_error) {}
  }

  function normalizeIncompleteUrl() {
    var url = currentUrl();
    if (!url) return;
    if (url.searchParams.get('state') !== 'complete') return;
    url.searchParams.delete('state');
    url.searchParams.delete('record_id');
    if (url.searchParams.get('intent') === 'check-in-complete')
      url.searchParams.set('intent', 'check-in');
    try {
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (_error) {}
  }

  function restore(root) {
    var url = currentUrl();
    if (!url || url.searchParams.get('state') !== 'complete') return false;
    var id = clean(url.searchParams.get('record_id'));
    var owner = storageOwner();
    if (!id || !owner) return false;
    var card = null;
    try {
      card = owner.getResult(id);
    } catch (_error) {}
    if (!card) {
      normalizeIncompleteUrl();
      root.setAttribute('data-checkin-state', 'active');
      root.removeAttribute('data-checkin-record-id');
      return false;
    }
    return reveal(root, card);
  }

  function bootRoot(root) {
    if (!root || root.getAttribute('data-checkin-route-bound') === VERSION) return;
    root.setAttribute('data-checkin-route-bound', VERSION);
    root.setAttribute('data-checkin-route', 'canonical');
    root.setAttribute('data-checkin-state', 'active');

    var attempts = 0;
    (function attemptRestore() {
      attempts += 1;
      if (restore(root)) return;
      var url = currentUrl();
      if (!url || url.searchParams.get('state') !== 'complete' || attempts >= 80) return;
      window.setTimeout(attemptRestore, 50);
    })();
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) bootRoot(target);
    Array.prototype.slice
      .call(target.querySelectorAll ? target.querySelectorAll(ROOT_SELECTOR) : [])
      .forEach(bootRoot);
  }

  window.addEventListener('littleg:mission_complete', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var card = detail.card || null;
    var id = resultId(card);
    if (!id) return;
    var root = detail.rootId
      ? document.getElementById(detail.rootId)
      : document.querySelector(ROOT_SELECTOR);
    if (!(root instanceof HTMLElement)) return;
    reveal(root, card);
    writeCompleteUrl(id, true);
  });

  window.addEventListener('popstate', function () {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!(root instanceof HTMLElement)) return;
    if (!restore(root)) root.setAttribute('data-checkin-state', 'active');
  });

  if (document.readyState === 'loading')
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) {
    boot(event && event.target ? event.target : document);
  });
})(window, document);
